import React from 'react';
import queryString from 'query-string';
import {lightColor} from '@ey/styled-theme';
import {currentResource, labels} from './utils';
import env from '../util/env';
import {
	numberFormatsListItems,
	timezones,
	dateFormatsListItems,
	userTheme,
	natureOfEngagements,
	concurrencyErrorCode,
	inventedConcurrencyErrorCode,
	userDoesNotHavePermissionOnAllEntitiesErrorCode,
	newUserDoesNotHavePermissionOnAllEntitiesErrorCode,
	contactHasBeenDeletedErrorCodeCustomAttributes,
	newContactHasBeenDeletedErrorCodeCustomAttributes,
	userIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes,
	newUserIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes,
	groupRiskAssessmentPropName,
	groupRiskAssessmentAccessViewRoles,
	hour
} from '../util/uiconstants';
import dompurify from 'dompurify';
import moment from 'moment';
import envConfig from '@ey/voltron-config';
import {isArray} from 'lodash';
class Utility extends Object {
	static getCanvasBaseUrl = (engagement, displayLanguage) => {
		let curl = env.getURL('eng_web') + '/pages/index/index.html?';
		curl = `${curl}countryid=${engagement.countryId}&`;
		curl = `${curl}engagementid=${engagement.engagementId}&`;
		curl = engagement.clientid ? `${curl}clientid=${engagement.clientid}` : curl;
		curl = engagement.clientname ? `${curl}clientname=${encodeURIComponent(engagement.clientname)}` : curl;
		curl = `${curl}workspacedesc=${encodeURIComponent(engagement.workspaceDescription)}&`;
		curl = `${curl}workspaceid=${engagement.workspaceId}&`;
		curl = `${curl}userPrefLang=${displayLanguage ? displayLanguage : ''}&`;
		curl = `${curl}engagementversion=${engagement.engagementVersion}`;
		return curl;
	};

	static getAutomationHubLink = (baseCanvasUrl, engagement) => {
		if (envConfig.IsSmartAutomationHubAvailable === 'false') {
			return baseCanvasUrl + '#automationhub';
		} else {
			return `${env.getURL('Smart_Automation_Url')}?engagementid=${engagement.engagementId}&countryId=${
				engagement.countryId
			}`;
		}
	};

	static getErrorMessageFromResponse(responseMessage) {
		let error;
		try {
			if (responseMessage && responseMessage.indexOf(' - ') > 0) {
				error = responseMessage.substr(0, responseMessage.indexOf(' -'));
			}
		} catch (err) {}
		if (error && error.length > 0 && !Array.isArray(error)) {
			if (error == concurrencyErrorCode) return '';
			if (error == userDoesNotHavePermissionOnAllEntitiesErrorCode) return '';
			if (error == inventedConcurrencyErrorCode) return responseMessage;
			if (error == newUserDoesNotHavePermissionOnAllEntitiesErrorCode) return responseMessage;
			if (error == contactHasBeenDeletedErrorCodeCustomAttributes) return '';
			if (error == newContactHasBeenDeletedErrorCodeCustomAttributes) return responseMessage;
			if (error == userIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes) return '';
			if (error == newUserIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes) return responseMessage;

			if (!error.ErrorCode) {
				const errorValue = Number(error);
				if (!isNaN(errorValue)) {
					return currentResource.Errors[errorValue]
						? error + ': ' + currentResource.Errors[errorValue]
						: responseMessage;
				}
			}
		}
		return responseMessage;
	}

	static getErrorCodeFromResponse(responseMessage) {
		let error;
		try {
			if (responseMessage && responseMessage.indexOf(' - ') > 0) {
				error = responseMessage.substr(0, responseMessage.indexOf(' -'));
			}
		} catch (err) {}
		if (error && error.length > 0 && !Array.isArray(error)) {
			if (!error.ErrorCode) {
				const errorValue = Number(error);
				if (!isNaN(errorValue)) {
					return errorValue;
				}
			}
		}
		return responseMessage;
	}

	//Return the error message from the object of the API.Error number optional.
	static getErrorMessage = (result, showErrorNumber) => {
		let displayError =
			result &&
			result.response &&
			result.response.data &&
			result.response.data.errors &&
			result.response.data.errors.Body &&
			result.response.data.errors.Body.length > 0 &&
			result.response.data.errors.Body[0];

		return displayError !== undefined ? displayError : '';
	};

	//Return the error message from the object of the API.Error number optional.
	static getErrorFromResponse = (result) => {
		const displayError =
			result &&
			result.response &&
			result.response.data &&
			result.response.data.errors &&
			result.response.data.errors.Error &&
			result.response.data.errors.Error.length > 0 &&
			result.response.data.errors.Error[0];

		return displayError !== undefined ? displayError : '';
	};

	static getEngagementIdFromUrl() {
		let query = queryString.parse(location.search.toLowerCase());
		let engId = query.engagementid;

		return engId;
	}

	static getProjectIdFromUrl() {
		let query = queryString.parse(location.search.toLowerCase());
		let projectId = query.projectid;

		return projectId;
	}

	/**
	 * sort an array by given keys.
	 * @param {Array} toSort - the array to sort.
	 * @returns {any} the sortedArray
	 * */
	static sortByMultipleKey(toSort) {
		let key = '';

		// check if toSort is array
		if (Array.isArray(toSort)) {
			if (toSort.length === 0) return 0;
			key = toSort[0];
		} else {
			key = toSort;
		}

		return function(a, b) {
			// nulls sort after anything else
			if (a[key] === null) {
				return 1;
			} else if (b[key] === null) {
				return -1;
			}
			// otherwise, if we're ascending, lowest sorts first
			else if (a[key] < b[key]) {
				return -1;
			}
			// if descending, highest sorts first
			else if (a[key] > b[key]) {
				return 1;
			}
			// equal items sort equally
			else {
				if (toSort.slice(1).length > 0) {
					return Utility.sortByMultipleKey(toSort.slice(1))(a, b);
				} else return 0;
			}
		};
	}

	/**
	 * Creates a rich text element to show rich text. Eg. (Bold, Italic, Underline...)
	 * rastwe: TODO: need some justification for having this here. Kendo editor?
	 * @param {string} text - the text to display
	 * @returns {Object} a rich text element to display
	 * */
	static createRichTextElement(text, styleName) {
		/*why are we doing this? The text was created with Kendo which handles sanitizing. If you are showing
		text that was not created with a kendo editor in rich text view, I dont know why you would, but use the below
		function which seems useless as well. This will be removed soon.*/

		/*const sanitizer = dompurify.sanitize;
		text = sanitizer(_.unescape(text));*/
		return <span className={styleName ?? ''} dangerouslySetInnerHTML={Utility.createMarkup(text)} />;
	}

	/**
	 * Get a sanitized text after parsing input for XSS.
	 * @param {string} text - the input text
	 * @returns {string} sanitized text
	 * */
	static getSanitizedText(text, encode) {
		const sanitizer = dompurify.sanitize;
		let sanitizedText = _.unescape(sanitizer(text));
		if (encode) {
			sanitizedText = encodeURIComponent(sanitizedText);
		}
		return sanitizedText;
	}

	/**
	 * Private function to return html required for setting dangerous inner html
	 * @param {string} text - the text to display
	 * @returns {Object} an object with html set to the text passed in
	 * */
	static createMarkup(text) {
		return {__html: text};
	}

	static getInnerTextLengthFromRichText(html) {
		let element = document.createElement('div');
		element.innerHTML = html;
		// fix special chart from Kendo: &#65279
		return element.innerText.replace(/\uFEFF/g, '').trim().length;
	}

	/**
	 * forms canvas inCountry base url.
	 * @param engagementInformation
	 * */
	static getCanvasBaseWebUrl(engagementInformation) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		let canvasUrl =
			inCountryBaseUrl +
			'/pages/index/index.html' +
			'?' +
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(engagementInformation.engagementDescription) +
			'&' +
			canvasUrlParams.workspacedesc +
			'=' +
			encodeURIComponent(engagementInformation.workspaceDescription) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.isInterim +
			'=' +
			engagementInformation.isInterimEngagement +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion;

		return canvasUrl;
	}

	static getFilterdData(searchedString, data, searchKeys) {
		let filteredData = data.filter((item) => {
			/* Search by specified keys */
			let dataSearched = _.some(searchKeys, (keyItem) => {
				return (
					keyItem &&
					keyItem.key &&
					item[keyItem.key] &&
					this.isTextIncluded(item[keyItem.key].toString(), searchedString)
				);
			});

			return dataSearched;
		});
		return filteredData;
	}

	static sortListData = (data = [], attributeName) => {
		if (isArray(data) && _.size(data) > 0) {
			return [...data].sort(function(a, b) {
				if (a[attributeName] && b[attributeName]) {
					return a[attributeName].localeCompare(b[attributeName]);
				}
				return 0;
			});
		}

		return data;
	};

	static getGroupedData(items, groupAttributeName, sortAttributeName) {
		const isProfileNature = groupAttributeName === 'profileNature';

		let groupedData = _.groupBy(items, groupAttributeName);

		const groupKeys = isProfileNature
			? Object.values(natureOfEngagements)
					.sort((a, b) => a.order - b.order)
					.map(({id}) => id)
					.filter((key) => Object.keys(groupedData).includes(`${key}`))
			: _.sortBy(Object.keys(groupedData));

		let sortedData = {};

		if (isProfileNature) {
			groupKeys.forEach((value) => {
				sortedData[currentResource.natureOfEngagementsLabels[value]] = this.sortListData(
					groupedData[value],
					sortAttributeName
				);
			});
			let unsortedData = [];
			if (groupedData[undefined]) {
				unsortedData = [...unsortedData, ...groupedData[undefined]];
			}
			if (groupedData[null]) {
				unsortedData = [...unsortedData, ...groupedData[null]];
			}
			if (groupedData[undefined] || groupedData[null]) {
				sortedData[labels.engagementTypeNotAvailable] = this.sortListData(unsortedData, sortAttributeName);
			}
		} else {
			groupKeys.forEach((value) => {
				sortedData[value] = this.sortListData(groupedData[value], sortAttributeName);
			});
		}

		groupedData = sortedData;
		return groupedData;
	}

	static sortGroupedData = (groupedData, groupName, sortAttributeName) => {
		groupedData.sort(function(a, b) {
			return a[groupName].localeCompare(b[groupName]);
		});

		groupedData.map((value) => {
			value[childListName] = value[childListName].sort(function(a, b) {
				return a[sortAttributeName].localeCompare(b[sortAttributeName]);
			});

			return value;
		});

		return groupedData;
	};

	/**
	 * Determines whether a text includes a certain value among its characters.
	 * @param  {String} source Text to be analized.
	 * @param  {String} target The text that could be included.
	 * @param  {Bool} takeInCountAccentMark The text that could be included.
	 * @return {Bool} A boolean indicating whether the second text is included or not.
	 */
	static isTextIncluded = (source, target, normalizeNfd = true) => {
		source = normalizeNfd ? this.normalizeNfd(source) : source;
		target = normalizeNfd ? this.normalizeNfd(target) : target;

		return source.includes(target);
	};

	/**
	 * Removes accent mark from a text.
	 * @param  {String} source Text to be cleaned.
	 */
	static normalizeNfd = (source) => {
		return source
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();
	};

	static getMilestoneOptionWithGroup = () => {
		let group = [...currentResource.auditPhases];
		let milestones = [...currentResource.milestones];

		// group by audit phase and find each milestone
		group.forEach((x) => {
			x.options = milestones.filter((m) => m.auditPhaseId === x.id);
		});

		return group;
	};

	/**
	 * Returns an array of translated days.
	 * */
	static getDaysOptions = () => {
		let result = [...currentResource.daysOptions];

		return result;
	};

	/**
	 * Returns a value according to the user's preferences.
	 * @param {string} format - User format preference
	 * @param {string} value - Value to be formatted
	 * @returns {string} a formatted number.
	 * */
	static getFormattedNumber(format, value) {
		let selectedFormat = numberFormatsListItems[0].locale;

		let userFormat = numberFormatsListItems.find((x) => x.label == format);
		if (userFormat) {
			selectedFormat = userFormat.locale;
		}

		return new Intl.NumberFormat(selectedFormat).format(value);
	}

	static removeTags(str) {
		if (!str || str === null || str === '') return false;
		else str = str.toString();
		return str.replace(/(<([^>]+)>)/gi, '');
	}

	static setMotifTheme = (themeName) => {
		document.getElementsByTagName('body')[0].setAttribute('motif-theme', themeName);
	};

	static adjustPercentages = (items) => {
		let totalPercentage = _.sum(items.map((data) => data.percentage));
		let item = _.maxBy(items, 'percentage');

		if (isNaN(totalPercentage)) {
			return items;
		}

		item.percentage = item.percentage + (100 - totalPercentage);

		return items;
	};

	static getTimezone = (id) => {
		let time = timezones.find((x) => x.id === id);

		return time?.timezone || 0;
	};

	static getDatetimeFromTimezone = (userTimezone, datetime, type = hour) => {
		const timeZoneNumber = this.getTimezone(userTimezone);
		let result = moment(datetime);
		if (timeZoneNumber >= 0) result = result.add(timeZoneNumber, type);
		else result = result.subtract(timeZoneNumber * -1, type);
		return result;
	};

	static getMotifTheme = () =>
		document.getElementsByTagName('body')[0].getAttribute('motif-theme') === userTheme.light ? null : userTheme.dark;

	static isDarkMode = () => this.getMotifTheme() === userTheme.dark;

	static getChartBorder = () => {
		return this.isDarkMode() ? lightColor['grey600'] : lightColor['white'];
	};

	static getFormattedDate = (date, userDateFormat) => {
		const getFormat = () => {
			let format = dateFormatsListItems[0].label;
			if (dateFormatsListItems.find((x) => x.label === userDateFormat)) {
				format = userDateFormat;
			}
			return format;
		};

		return this.isValidDate(date) && moment(date).format(getFormat());
	};

	static isValidDate = (date) => {
		return date && date.length > 0 && date !== '0001-01-01T00:00:00';
	};

	static normalize = (field, accumulator, key) => {
		let result;

		// If an accumulator is passed, the result should be at least, that
		if (accumulator) {
			result = {
				byId: {...accumulator.byId},
				allIds: [...accumulator.allIds]
			};
		}

		// If field was correctly passed and result is still undefined, initialize it
		if (!result) {
			result = {
				byId: {},
				allIds: []
			};
		}

		// Run array normalization logic
		if (Array.isArray(field)) {
			for (let k = 0; k < field.length; k++) {
				const entity = field[k];

				const index = key ? entity[key] : entity?.id;
				result.byId[index] = entity;
				result.allIds.push(index);
			}
		}

		return result;
	};

	static hasValue(value) {
		let result = false;

		switch (typeof value) {
			case 'object':
				if (Array.isArray(value)) {
					if (value.length > 0) {
						result = true;
					}
				} else {
					result = !_.isEmpty(value);
				}
				break;
			case 'string':
				if (value !== undefined && value !== null && value.trim() !== '') {
					result = true;
				}
				break;
			default:
				if (value !== undefined && value !== null) {
					result = true;
				}
				break;
		}

		return result;
	}

	static sendEmails = (emails, subject = '') => {
		const mailtoPrefix = 'mailto:';
		const subjectPrefix = 'subject=';
		const maxUrlCharacters = 1900 - encodeURIComponent(subject).length - subjectPrefix.length - mailtoPrefix.length - 1;
		const separator = ';';
		let currentIndex = 0;
		let nextIndex = 0;

		const buildEmail = (prefix, emails, subject) => `${prefix}${emails}?${subjectPrefix}${subject}`;

		if (emails.length < maxUrlCharacters) {
			window.open(buildEmail(mailtoPrefix, emails, subject), '_blank');
			return;
		}

		do {
			currentIndex = nextIndex;
			nextIndex = emails.indexOf(separator, currentIndex + 1);
		} while (nextIndex !== -1 && nextIndex < maxUrlCharacters);

		if (currentIndex === -1) {
			window.open(buildEmail(mailtoPrefix, emails, subject), '_blank');
		} else {
			window.open(buildEmail(mailtoPrefix, emails.slice(0, currentIndex), subject), '_blank');
			let timeout;
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				this.sendEmails(emails.slice(currentIndex + 1), subject);
			}, 100);
		}
	};

	static dateIsOverdue = (date) => {
		/* retrieve if the 'date' parameter is lower than today */

		if (this.isValidDate(date)) {
			const today = new Date();
			const dateToCheck = new Date(date);

			return dateToCheck.getTime() < today.getTime();
		}
		return;
	};

	static yeardateIsOverdue = (date) => {
		/* retrieve if the year of date parameter is lower than today year */

		if (this.isValidDate(date)) {
			const today = new Date();
			const dateToCheck = new Date(date);

			return dateToCheck.getUTCFullYear() < today.getUTCFullYear();
		}
		return;
	};

	static isUserHasAccessToGRA = (user) => {
		return user?.isProjectOwner || user?.roles?.some((role) => groupRiskAssessmentAccessViewRoles.includes(role));
	};

	static checkProjectTypeAndFilterColumns = (columns, isGroupRiskAssessment) => {
		return isGroupRiskAssessment ? columns : columns?.filter((f) => f.propName !== groupRiskAssessmentPropName);
	};

	static getJsonPatchDocumentElement(operation, property, propertyValue) {
		return { op: operation, path: property, value: propertyValue };
	}
}

export default Utility;
